const getters = {
    sidebar: state => state.app.sidebar,
    sonsMenu: state => state.permission.sonsMenu,
    parentPath: state => state.permission.parentPath,
    size: state => state.app.size,
    device: state => state.app.device,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    token: state => state.user.token,
    user: state => state.user.user,
    loadMenus: state => state.user.loadMenus,
    roles: state => state.user.roles,
    permission_routes: state => state.permission.routes,
    isLoadedRoute: state => state.permission.isLoadedRoute,
    errorLogs: state => state.errorLog.logs
}
export default getters